type EventCallback = (data?: any, payload?: any) => void;

export class EventEmitter {
    private eventListeners: { [key: string]: EventCallback[] } = {};

    on(event: string, callback: EventCallback) {
        if (!this.eventListeners[event]) {
            this.eventListeners[event] = [];
        }
        this.eventListeners[event].push(callback);
    }

    off(event: string, callback: EventCallback) {
        if (!this.eventListeners[event]) return;
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
    }

    emit(event: string, data?: any, payload?: any) {
        const listeners = this.eventListeners[event];
        if (listeners) {
            listeners.forEach(callback => callback(data, payload));
        }
    }
    
	getEvents(){
	    return this.eventListeners;
	}

}
